import { JobArea, JobPosition } from '__gql-generated__/types'

export const JOB_POSITIONS_OPTIONS_TRANSLATED = {
  [JobPosition.Teacher]: 'Professor(a)',
  [JobPosition.Administrative]: 'Administrativo',
  [JobPosition.Principal]: 'Diretor(a)',
  [JobPosition.AssistantOrIntern]: 'Assistente ou Estagiário(a)',
  [JobPosition.Financial]: 'Financeiro(a)',
  [JobPosition.Librarian]: 'Bibliotecário(a)',
  [JobPosition.EducationalTechnology]: 'Tecnologia Educacional',
  [JobPosition.SchoolSupport]: 'Serviços Gerais',
  [JobPosition.PedagogicalAdvisor]: 'Orientador(a) Pedagógico',
  [JobPosition.It]: 'TI',
  [JobPosition.Psychologist]: 'Psicólogo(a)',
  [JobPosition.Coordinator]: 'Coordenador(a)'
}

export const JOB_AREAS_OPTIONS_TRANSLATED = {
  [JobArea.LanguagesAndCommunication]: 'Linguagens e Comunicação',
  [JobArea.TechnologyAndInnovation]: 'Tecnologia e Inovação',
  [JobArea.ExpressionsAndBody]: 'Expressões e Corpo',
  [JobArea.HumanSciences]: 'Ciências humanas',
  [JobArea.ForeignLanguage]: 'Língua Estrangeira',
  [JobArea.PersonalDevelopment]: 'Desenvolvimento pessoal',
  [JobArea.MathematicsAndTechnologies]: 'Matemática e suas tecnologias',
  [JobArea.NaturalSciences]: 'Ciências da natureza'
}
